<template>
  <transition name="fade">
    <signin v-if="isLoginOpen" @close="onCloseSignin" @signup="isLoginOpen = false;isSignupOpen = true"/>
  </transition>

  <transition name="fade">
    <TMmodal v-show="TMOpen" :isOpen="TMOpen" :type="'header'" @close="onCloseTM"/>
  </transition>

  <transition name="fade">
    <join v-if="isSignupOpen" @close="onCloseSignup"/>
  </transition>

  <transition name="fade">
    <join-complete v-if="isSignupCompleteOpen" @close="isSignupCompleteOpen = false;isLoginOpen = true"/>
  </transition>

  <transition name="fade">
    <new-message v-if="isUnReadMessage" />
  </transition>

  <header v-if="gameCount" id="mainheader" :class="{ 'side': nside }">
    <div class="header">
      <div class="logowrap">
        <a @click="menuopen" class="mobile"><i class="fi fi-bs-menu-burger"></i></a>
        <a @click="goPageByName('main')">
          <img src="@/assets/img/mega-logo.png" alt="MEGA" />
        </a>
        <!-- <div class="topbannerin">
          <div class="speakerIcon"><img src="@/assets/img/icon_mega.svg"/></div>
          <span class="">{{$t('front.header.msg')}}</span>
        </div> -->
      </div>
      <div class="menuWrap">
        <ul class="">
          <li @click="goPageByName('charge')"><i class="fi fi-rr-wallet-arrow"></i>입금</li>
          <li @click="goPageByName('exchange')"><i class="fi fi-rr-wallet-income"></i>출금</li>
          <li @click="goPageByName('csCenter')"><i class="fi fi-ss-headset"></i>문의</li>
          <li @click="goPageByName('message')"><i class="fi fi-rr-envelope"></i>쪽지</li>
          <li @click="goPageByName('csCenter')"><i class="fi fi-rr-credit-card-check"></i>계좌문의</li>
          <li @click="goPageByName('info')"><i class="fi fi-rr-circle-user"></i>내정보</li>
        </ul>
        <div class="naviwrap" >
          <template v-if="!userData">
            <div class="loginWrap">
              <ui-button :className="'loginbtn headerbtn'" :text="$t('front.gnb.login')" @click="onClickLogin"/>
              <ui-button :className="'joinbtn headerbtn'" :text="$t('front.common.signup')" @click="onClickSignup"/>
            </div>
          </template>
          <template v-else>
            <ul class="coninpoint" v-if="userData">
              <li>
                <span>{{userData.memId}}님</span>
              </li>
              <li>
                <i class="fi fi-rs-sack-dollar"></i>
                보유머니 :
                <em>{{thousand(userData.cashAmt ? userData.cashAmt.toString() : '0')}}</em> 원
              </li>
              <li @click="goPageByName('point')"><i class="fi fi-rr-circle-p"></i>
                포인트 :
                <em>{{thousand(userData.pointAmt ? userData.pointAmt.toString() : '0')}}</em> P
              </li>
            </ul>
            <!-- <ul class="coninpoint" v-if="userData">
              <li>
                 <i class="icon"><img src="@/assets/img/icon/icon_user.svg" /></i>
                 <span @click="goPageByName('messageList')">
                    <em>받은 쪽지</em>
                    {{thousand(unReadMessageCount ? unReadMessageCount.toString() : '0')}}
                 </span>
              </li>
              <li>
                 <span>
                    <em>{{$t('front.give.haveCash')}}</em>
                    {{thousand(userData.cashAmt ? userData.cashAmt.toString(): '0')}}
                 </span>
              </li>
              <li>
                 <button class="headerbtn_coinplus" @click="goPageByName('charge')">
                    <img src="@/assets/img/icon/icon_plusw.svg" />
                 </button>
              </li>
              <li>
                <span>
                    <em>{{$t('front.cash.nav4')}}</em>
                    {{thousand(userData.pointAmt ? userData.pointAmt.toString() : '0')}}
                 </span>
              </li>
              <li>
                <button class="headerbtn_coinplus" @click="goPageByName('point')">
                  <img src="@/assets/img/icon/icon_plusw.svg" />
                </button>
              </li>
            </ul> -->
            <button class="logoutBtn" @click="signOut">로그아웃</button>
          </template>
        </div>
      </div>
    </div>
    <div class="header-bot" :class="{ 'out': isOpen }">
      <ul class="mobile">
          <li @click="goPageByName('charge');isOpen=true" ><i class="fi fi-rr-wallet-arrow"></i>입금</li>
          <li @click="goPageByName('exchange');isOpen=true"><i class="fi fi-rr-wallet-income"></i>출금</li>
          <li @click="goPageByName('csCenter');isOpen=true"><i class="fi fi-ss-headset"></i>문의</li>
          <li @click="goPageByName('message');isOpen=true"><i class="fi fi-rr-envelope"></i>쪽지</li>
          <li @click="goPageByName('csCenter');isOpen=true"><i class="fi fi-rr-credit-card-check"></i>계좌문의</li>
          <li @click="goPageByName('info');isOpen=true"><i class="fi fi-rr-circle-user"></i>내정보</li>
      </ul>
      <ul class="">
        <small class="mobile">GAMES & SPORTS</small>
        <!-- <li @click="goPageByName('listsports');isOpen=true">스포츠</li> -->
        <!-- <li @click="goPageByName('listlivesports');isOpen=true">실시간스포츠</li> -->
        <li @click="goPageByName('listcasino');isOpen=true">라이브카지노</li>
        <li @click="goPageByName('listslot');isOpen=true">슬롯게임</li>
        <!-- <li @click="goPageByName('listhotel');isOpen=true">호텔카지노</li> -->
        <!-- <li @click="goPageByName('listmini');isOpen=true">미니게임</li> -->
        <small class="mobile">MAIN MENU</small>
        <li @click="goPageByName('bettingList');isOpen=true" class="umenu">베팅내역</li>
        <li @click="goPageByName('couponUse');isOpen=true" class="umenu">쿠폰</li>
        <li @click="goPageByName('noticeList');isOpen=true" class="umenu">공지사항</li>
        <li @click="goPageByName('csCenter');isOpen=true" class="umenu">고객센터</li>
        <li
          v-if="userData && userData.isPartnerMember === 'Y'"
          :class="{ on: $route.name === 'partner' }"
          class="partner"
        >
          <a
            :href="`https://${partnerDomain}/partnerMain`"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t('front.common.partner') }}
          </a>
        </li>
        <li style="display: none;"></li>
      </ul>
    </div>
  </header>
</template>

<script>

import UiButton from '@/components/ui/UiButton'

import { mapState } from 'vuex'
import Join from '@/components/member/Join'
import JoinComplete from '@/components/member/JoinComplete'
import Signin from '@/components/member/Signin'
import TMmodal from '@/components/common/TotalMoney'
import { TRIPLE_GAME_LIST } from '@/libs/constants'
import NewMessage from '@/components/member/Message.vue'
import { getMainCashStatus } from '@/api/main'

export default {
  name: 'Header',
  components: {
    NewMessage,
    Signin,
    JoinComplete,
    Join,
    UiButton,
    TMmodal
  },
  data () {
    return {
      menuList: [],
      TMOpen: false,
      isLoginOpen: false,
      isSignupOpen: false,
      isSignupCompleteOpen: false,
      showMenu: false,
      showMenuMoney: false,
      showMenuLang: false,
      isAlertOpen: false,
      isGameOpen: false,
      isHgameOpen: false,
      isSlotOpen: false,
      isSportsOpen: false,
      isMiniOpen: false,
      isCashOpen: false,
      tripleGameList: TRIPLE_GAME_LIST,
      nside: true,
      cashOutList: [],
      leftOutTab: 'charge',
      isOpen: true
    }
  },
  watch: {
    $route: {
      handler (current) {
        this.gnbReset()
      }
    }
  },
  props: ['selectedMenu'],
  created () {
    this.setMenu()
    this.getHeadMsgList()
    this.loadCashStatus()
  },
  computed: {
    ...mapState([
      'userData',
      'coinAmt',
      'commonCodeByOrder',
      'gameCount',
      'unReadMessageCount',
      'siteOption'
    ]),
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    },
    partnerDomain () {
      const hostname = window.location.hostname
      if (hostname.includes('port-folio.cc')) return 'd29.port-folio.cc'
      return 'd29.port-folio.cc' // 기본값
    }
  },
  methods: {
    loadCashStatus () {
      getMainCashStatus({}).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.cashInList = result.data.cashInList.slice(0, this.listMaxCount)
          this.cashOutList = result.data.cashOutList.slice(0, this.listMaxCount)
        }
      })
    },
    slotOpen (event, groupCode, codeName, code) {
      this.emitter.emit(event, { groupCode, codeName, code })
    },
    gnbReset () {
      this.isGameOpen = false
      this.isHgameOpen = false
      this.isSlotOpen = false
      this.isSportsOpen = false
      this.isMiniOpen = false
      this.isCashOpen = false
      this.showMenu = false
      this.showMenuLang = false
    },
    menuopen () {
      this.isOpen = !this.isOpen
    },
    gnbMenuOpen (type) {
      this.gnbReset()
      if (type === 'game') {
        this.isGameOpen = true
      } else if (type === 'hgame') {
        this.isHgameOpen = true
      } else if (type === 'slot') {
        this.isSlotOpen = true
      } else if (type === 'cash') {
        this.isCashOpen = true
      } else if (type === 'mypage') {
        this.showMenu = true
      } else if (type === 'lang') {
        this.showMenuLang = true
      } else if (type === 'sport') {
        this.isSportsOpen = true
      } else if (type === 'minigame') {
        this.isMiniOpen = true
      }
    },
    getHeadMsgList () {
      // getHeadMsg({}).then(response => {
      //   console.log(response)
      // })
    },
    setMenu () {
      const list = this.$router.getRoutes()
      for (let i = 0, iLen = list.length; i < iLen; i++) {
        const item = list[i]
        if (item.meta && item.meta.gnb) {
          item.isSubOpen = false
          this.menuList.push(item)
        }
      }
    },
    onClickGame (code, name) {
      this.gnbReset()
      if (code) {
        // minigame

        if (code === 'mg') {
          this.$router.push({ name: name })
        } else {
          this.onSelectGame(code)
        }
      } else {
        this.onCheck('준비 중입니다.')
      }
    },
    onClickGnb (item) {
      const name = item.name
      const meta = item.meta
      if (meta.game) {
        this.onSelectGame(meta.gameCode)
      } else {
        this.$router.push({ name: name })
      }
    },
    async onClickTM () {
      const confirmMessage = '통합머니 전환을 진행하시겠습니까?'
      const confirmResult = await this.onConfirm(confirmMessage)
      if (confirmResult) {
        this.TMOpen = true
      }
    },
    onCloseTM () {
      this.TMOpen = false
    },
    onClickLogin () {
      this.isLoginOpen = true
      this.isSignupOpen = false
    },
    onClickSignup () {
      this.isLoginOpen = false
      this.isSignupOpen = true
    },
    onCloseSignin (value) {
      this.isLoginOpen = false
      if (value === 'join') {
        this.isSignupOpen = true
      }
      if (value === 'signin') {
        // location.reload()
      }
    },
    onCloseSignup (status) {
      this.isSignupOpen = false
      if (status) {
        this.isSignupCompleteOpen = true
      }
    }
  }
}
</script>

<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
